export interface SpinState {
  maskMain: boolean;
  maskView: boolean;
  splash: boolean;
  maskGrandAccess: boolean;
}

const state: SpinState = {
  maskMain: false,
  maskView: false,
  splash: false,
  maskGrandAccess: false,
};

export default state;
